export default (value: any): value is HTMLElement =>
  value instanceof HTMLElement;
